import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CourseListComponent } from './course-list/course-list.component';
import { CourseCreateComponent } from './course-create/course-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: CourseListComponent,
        data: {
          title: "Course List",
          breadcrumb: "Course List"
        }
      },
      {
        path: 'create',
        component: CourseCreateComponent,
        data: {
          title: "Create Course",
          breadcrumb: "Create Course"
        }
      },
      {
        path: 'edit/:id',
        component: CourseCreateComponent,
        data: {
          title: "Edit Course",
          breadcrumb: "Edit Course"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class CourseRoutingModule { }
